// extracted by mini-css-extract-plugin
export var banner = "_fk-0";
export var closeButton = "_fk-2";
export var greenCheckmark = "_fk-3";
export var hereLink = "_fk-4";
export var titleIcon = "_fk-1";